/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Delete_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "Members of this share will lose access the next time they sync." |
*
* @param {Team_Share_Delete_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_delete_confirm_text = /** @type {((inputs?: Team_Share_Delete_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Delete_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
	return /** @type {LocalizedString} */ ("Members of this share will lose access the next time they sync.")
});